var React = require('react');

function ModalClose (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1.66602","width":"31.5839","height":"2.35701","transform":"rotate(45 1.66602 0)","fill":"#00443B","key":0}),React.createElement("rect",{"y":"22.334","width":"31.5839","height":"2.35701","transform":"rotate(-45 0 22.334)","fill":"#00443B","key":1})]);
}

ModalClose.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ModalClose;

ModalClose.default = ModalClose;
